export const AboutUs = () => {
  return (
    <div
      className="relative"
      style={{
        minHeight: '100%',
        backgroundImage: 'url("../images/abstract_bg_white.svg")',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}>
      <div
        style={{
          background:
            'linear-gradient(to bottom, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, .85) 100%)',
          height: '100%'
        }}
        className=" px-3 py-3 text-justify">
        شرکت فرا رایانه آسان درمان (فراد) یک شرکت نرم افزاری است که در راستای تسهیل و بهبود خدمات
        پزشکی و سلامت جامعه فعالیت میکند. اعضای اصلی این شرکت از مهندسان و پزشکان خبره تشکیل شده است
        و همین موضوع باعث شده که نرم افزار های تولید شده توسط این شرکت منطبق ترین حالت با نیاز
        پزشکان و سلامت جامعه باشد. نرم افزار پیش روی شما با نام تجاری مدمی (MedMe), یک نرم افزار
        تشخیصی برپایه الگوریتم های روز پزشکی می باشد. این الگوریتم ها توسط پزشکان متخصصی که با شرکت
        فراد قرارداد همکاری دارند تهیه و نظارت شده و در اين برنامه تحت مالکیت شرکت فراد مورد استفاده
        قرار گرفته است. همچنین محتوای ارائه شده در این پلتفرم و همینطور حقوق مادی و معنوی آن ها به
        طور کامل متعلق به شرکت فراد (فرا رایانه آسان درمان) می باشد و کسانی که نام آنها به عنوان
        سازنده محتوا در پایین هر محتوا آورده شده است با شرکت فراد قرارداد همکاری دارند و آوردن نام
        آنها صرفا نشان دهنده این است که این محنوا توسط چه کسانی تولید شده است. اما حق استفاده و
        انتشار آن برای شرکت فرا رایانه آسان درمان (فراد) محفوظ می باشد. ضمنا هرگونه کپی برداری یا
        استفاده از این محتوا ها یا فیلم ها یا مطالب آورده شده در اين نرم افزار بدون رضایت کتبی شرکت
        فرا رایانه آسان درمان پیگرد قانونی خواهد داشت. همینطور هرگونه کپی برداری یا الهام گرفتن از
        طرح ظاهری و یا نحوه ارایه مطالب این نرم افزار, نیز پیگرد قانونی خواهد داشت چراکه این طرح
        ظاهری و اصطلاحا UI تماما متعلق به شرکت فرا رایانه آسان درمان می باشد. پزشکان و تولید کنندگان
        محتوایی که قصد همکاری با اين مجموعه را نیز دارند می توانند درخواست خود را به نشانی ایمیل{' '}
        <a href="mailto:admin@faraad.org" target="_blank" rel="noreferrer">
          admin@faraad.org
        </a>{' '}
        ارسال کنند تا پس از بررسی پيشنهاد ایشان و دعوت حضوری از ایشان و عقد قرارداد. به تولید محتوا
        در استودیو شرکت فرا رایانه آسان درمان بپردازند و شرکت فراد که مالک محتوا می باشد آن را در
        پلتفرم خود منتشر کند.
      </div>
    </div>
  );
};
